import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TextCell = styled.div`
  ${typographyV2.bodySm};
  font-family: var(--font-nort);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
`;
